import { render, staticRenderFns } from "./profit-report.vue?vue&type=template&id=52f519ae&scoped=true"
import script from "./profit-report.vue?vue&type=script&lang=js"
export * from "./profit-report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f519ae",
  null
  
)

export default component.exports